import { ViewController } from '@estee/elc-service';
import { observable, computed, action } from 'mobx';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { EmailOptInRepository } from '../repositories/EmailOptInRepository';
import { EmaiOptInViewLoadedUseCase } from '../use-cases/EmaiOptInViewLoadedUseCase';

export class EmailOptInViewController extends ViewController {
    @observable private emailOptInRepository: EmailOptInRepository;

    constructor() {
        super();
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);
    }

    @computed
    public get data() {
        return {
            emailOptIn: this.isEmailSubscribed,
            toggleOptIn: this.emailOptIn.toggleEmailSubscribed
        };
    }

    @action
    public onEmailOptInCheck = () => {
        this.data.toggleOptIn();
    };

    @computed
    get emailOptIn() {
        return this.emailOptInRepository.emailOptIn;
    }

    @computed
    get isLoaded() {
        return !this.isLoading && this.emailOptIn;
    }
    @computed
    public get isEmailSubscribed() {
        return this.emailOptIn.emailSubscribed;
    }

    @action
    public loaded = async () => {
        this.isLoading = true;
        const emaiOptInViewLoadedUseCase = new EmaiOptInViewLoadedUseCase();
        await emaiOptInViewLoadedUseCase.execute();
        this.isLoading = false;
    };
}
